<div class="modal">
  <div class="modal-header">
    <h2>Mark as Lost</h2>
    <button class="close-btn" (click)="onClose()">×</button>
  </div>
  <div class="modal-body">
    <form [formGroup]="reasonForm" (ngSubmit)="onSubmit()">
      <div class="form-group">
          <app-select
              [options]="lostReasons"
              formControlName="lost_reason"
              [placeholder]="'Select a reason'"
              [formControl]="$any(reasonForm).get('lost_reason')"
              [displayKey]="'reason'"
              [valueKey]="'id'"
              >
          </app-select>
      </div>

      <div class="form-group">
        <label for="lost_comment">Comments (optional)</label>
        <textarea id="lost_comment" formControlName="lost_comment" class="form-control" rows="4"></textarea>
      </div>

      <div class="modal-footer">
        <mat-icon
          *ngIf="hasSettingsAccess"
          class="settings-icon"
          matTooltip="Configure lost reasons"
          matTooltipPosition="above"
          (click)="goToLostReasonsSettings()">
          settings
        </mat-icon>
        <div class="footer-actions">
          <button type="button" class="btn btn-secondary" (click)="onClose()">Cancel</button>
          <button
              type="submit"
              class="btn btn-danger"
              [disabled]="reasonForm.invalid"
              [ngClass]="{ 'not-allowed-cursor': reasonForm.invalid }">
              Mark as Lost
          </button>
        </div>
      </div>
    </form>
  </div>
</div>